<template>
    <span>
        <b-button
            v-b-modal="`multiple_orders_send_modal`"
            :variant="buttonStyle.variant"
            :class="buttonStyle.class"
            :size="buttonStyle.size"
            @click="checkOrders"
            >{{ $t("send") }}</b-button
        >

        <b-modal
            :id="`multiple_orders_send_modal`"
            title="Send orders"
            ref="send_order_modal"
            footer-class="p-2"
        >
            <b-alert show v-if="invalid_refs">
                This purchase orders contains invalid SKU(s). You will be
                notified when those have been added to our product library.
            </b-alert>

            {{ $t("send_dialog_are_you_sure") }}

            <template v-slot:modal-footer="{ cancel }">
                <b-button @click="cancel()" :disabled="sending">
                    {{ $t("cancel") }}
                </b-button>
                <b-button variant="primary" @click="send" :disabled="sending">
                    {{ $t("yes_send_now") }}
                </b-button>
            </template>
        </b-modal>
    </span>
</template>

<script>
import axios from "axios";

export default {
  name: "OrdersSendMultiple",
  props: {
    orders: {
      type: Array,
      default: null
    },
    buttonStyle: {
      type: Object,
      default: () => ({
        variant: "primary",
        class: "",
        size: ""
      })
    }
  },
  data() {
    return {
      sending: false,
      invalid_refs: false
    };
  },
  methods: {
    async send() {
      let isErrorOnSend = false;
      let passportErrorFromAPI = "Passport limit reached for this company.";
      let errorMessage = "Error while sending one or more orders.";
      let errorPassport =
        "You have reached the limit of passports you can generate. Please contact our services to unlock more passports.";
      let orderSentCount = 0;
      let errorCode = 0;

      this.sending = true;

      const sendOrderSequentially = async orderIndex => {
        if (orderIndex < this.orders.length) {
          const order = this.orders[orderIndex];
          try {
            const response = await axios.put(`/api/orders/${order.id}/send`);
            if (response.status === 204) {
              orderSentCount++;
            } else {
              isErrorOnSend = true;
              if (response.data.message === passportErrorFromAPI) {
                errorCode = 1;
                errorMessage = errorPassport;
              }
            }
          } catch (error) {
            isErrorOnSend = true;
            if (error.response.data.message === passportErrorFromAPI) {
              errorCode = 1;
              errorMessage = errorPassport;
            }
            // You can handle different error cases here
          }

          // Continue sending the next order after a short delay (e.g., 1000ms or 1 second)
          setTimeout(() => {
            sendOrderSequentially(orderIndex + 1);
          }, 1000);
        } else {
          // All orders have been sent or attempted
          if (isErrorOnSend) {
            if (orderSentCount !== 0) {
              if (errorCode === 1) {
                errorMessage = errorPassport;
              }
            }
            this.$emit("error", {
              message: errorMessage,
              errorCode: errorCode,
              partialSent: orderSentCount !== 0
            });
          } else {
            this.$emit("success", {
              message: "All orders have been sent."
            });
          }

          this.$refs["send_order_modal"].hide();
          this.sending = false;
        }
      };

      // Start sending orders sequentially from index 0
      sendOrderSequentially(0);
    },
    checkOrders() {
      this.orders.forEach(order => {
        let invalid_refs = 0;
        axios
          .get(`/api/orders/` + order.id)
          .then(response => (invalid_refs = response.data.data.invalid_refs))
          .finally(() => {
            this.setInvalidRefs(invalid_refs);
          });
      });
    },
    setInvalidRefs(invalid_refs) {
      if (invalid_refs > 0) {
        this.invalid_refs = true;
      }
    }
  }
};
</script>
